var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('ResetPassword',{attrs:{"show-dialog":_vm.showForm},on:{"hide":function($event){_vm.showForm = false}}}),_c('q-btn',{staticClass:"q-px-sm",attrs:{"flat":"","dense":"","size":"13px","icon":"far fa-lock","label":"Reset password","color":_vm.inline? 'primary':'dark-gray'},on:{"click":function($event){_vm.showForm = !_vm.showForm}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }